<!-- Page Header -->
<div class="page-header">
  <div class="header-icon">
    <i class="pi pi-print"></i>
  </div>
  <div class="header-content">
    <h1 class="header-title">{{ texts.titulo }}</h1>
    <p class="header-subtitle">{{ texts.subtitulo }}</p>
  </div>
</div>

<div class="table-card">
  <div class="card-header">
    <div class="card-header-icon table-icon">
      <i class="pi pi-list"></i>
    </div>
    <span class="card-header-title">{{ texts.lista }}</span>
    <div class="card-header-actions">
      <button pButton [label]="texts.nova" icon="pi pi-plus"
        (click)="novaImpressora()" class="btn-primary btn-sm"></button>
    </div>
  </div>

  <div class="card-content">
    <!-- Barra de busca + Seletor de colunas -->
    <div class="search-bar">
      <p-iconField iconPosition="right" class="search-field">
        <p-inputIcon styleClass="pi pi-search" />
        <input pInputText type="text" [placeholder]="placeholders.pesquisar"
          [ngModel]="filterName" (ngModelChange)="onSearchChange($event)" />
      </p-iconField>

      <app-column-selector
        [columns]="columns"
        [storageKey]="STORAGE_KEY"
        (columnsChange)="onColumnsChange($event)">
      </app-column-selector>
    </div>

    <!-- Tabela -->
    <p-table [value]="impressorasDaPagina" [loading]="loading"
      [customSort]="true"
      (sortFunction)="customSort($event)"
      [tableStyle]="{ 'width': '100%' }">

      <ng-template pTemplate="header">
        <tr>
          <th [hidden]="!isColumnVisible('id')" pSortableColumn="id" style="width: 8%">
            {{ labels.id }}<p-sortIcon [field]="'id'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('codigo')" pSortableColumn="codigo" style="width: 12%">
            {{ labels.codigo }}<p-sortIcon [field]="'codigo'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('nome')" pSortableColumn="nome" style="width: 35%">
            {{ labels.nome }}<p-sortIcon [field]="'nome'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('caminho')" pSortableColumn="caminho" style="width: 33%">
            {{ labels.caminho }}<p-sortIcon [field]="'caminho'"></p-sortIcon>
          </th>
          <th [hidden]="!isColumnVisible('acoes')" style="width: 12%">{{ labels.acoes }}</th>
        </tr>
      </ng-template>

      <ng-template pTemplate="body" let-impressora>
        <tr>
          <td [hidden]="!isColumnVisible('id')">{{ impressora.id }}</td>
          <td [hidden]="!isColumnVisible('codigo')">{{ impressora.codigoImpressora }}</td>
          <td [hidden]="!isColumnVisible('nome')">{{ impressora.nome }}</td>
          <td [hidden]="!isColumnVisible('caminho')" class="caminho-cell">{{ impressora.caminho }}</td>
          <td [hidden]="!isColumnVisible('acoes')" class="actions">
            <button pButton icon="pi pi-trash"
              class="p-button-text p-button-rounded p-button-sm action-btn delete-btn"
              [pTooltip]="tooltips.excluir" tooltipPosition="top"
              (click)="confirmarExclusao(impressora)"></button>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="emptymessage">
        <tr>
          <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
            <div class="flex flex-column align-items-center">
              <i class="pi pi-inbox text-gray-400" style="font-size: 3rem; margin-bottom: 1rem;"></i>
              <div class="text-gray-500 text-lg">{{ texts.nenhuma }}</div>
              <div class="text-gray-400 text-sm mt-1">{{ texts.ajuste_filtros }}</div>
            </div>
          </td>
        </tr>
      </ng-template>

      <ng-template pTemplate="loadingbody">
        <tr>
          <td [attr.colspan]="visibleColumnCount" class="text-center p-5">
            <div class="flex justify-content-center align-items-center">
              <i class="pi pi-spinner pi-spin" style="font-size: 2rem;"></i>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>

    <!-- Paginacao -->
    <div class="pagination-container">
      <div>
        <p-paginator (onPageChange)="onPageChange($any($event))"
          [showCurrentPageReport]="true"
          currentPageReportTemplate="{first} - {last} de {totalRecords}"
          [first]="first" [rows]="rows"
          [totalRecords]="totalRecords"
          [showFirstLastIcon]="true">
        </p-paginator>
      </div>
      <div class="flex align-items-center">
        <span class="mx-1 text-color">{{ labels.itens_por_pagina }}</span>
        <p-dropdown [options]="pageSizeOptions" optionLabel="label"
          optionValue="value" [(ngModel)]="rows"
          (ngModelChange)="onRowsPerPageChange()" styleClass="w-6rem"
          appendTo="body">
        </p-dropdown>
      </div>
    </div>
  </div>
</div>

<p-toast></p-toast>

<!-- Cadastro: mesmo dialog usado no cadastro rapido dos seletores -->
<app-impressora-adicionar-dialog
  [(visible)]="dialogVisible"
  (impressoraCriada)="onImpressoraCriada()">
</app-impressora-adicionar-dialog>

<!-- Confirmacao de exclusao (Wave Design) -->
<p-dialog [(visible)]="deleteDialogVisible" [showHeader]="false" [modal]="true"
  [closable]="false" [draggable]="false" styleClass="dialog-wave-redesign" [style]="{ width: '30rem' }">
  <div class="dialog-wave-header dialog-wave-header--danger">
    <div class="dialog-wave-header-content">
      <div class="dialog-wave-icon-container">
        <i class="pi pi-trash" aria-hidden="true"></i>
      </div>
      <div class="dialog-wave-header-text">
        <h2>{{ texts.confirmacao }}</h2>
        <p>{{ texts.confirmacao_excluir }}</p>
      </div>
    </div>
    <div class="dialog-wave-decorative-circle circle-1" aria-hidden="true"></div>
    <div class="dialog-wave-decorative-circle circle-2" aria-hidden="true"></div>
    <svg class="dialog-wave-svg" viewBox="0 0 1200 40" preserveAspectRatio="none" aria-hidden="true">
      <path d="M0,20 C150,40 350,0 500,20 C650,40 850,0 1000,20 C1100,32 1150,20 1200,20 L1200,40 L0,40 Z" fill="white"/>
    </svg>
  </div>
  <ng-template pTemplate="footer">
    <button pButton [label]="botoes.cancelar" class="p-button-secondary"
      (click)="deleteDialogVisible = false" [disabled]="excluindo"></button>
    <button pButton [label]="botoes.confirmar" severity="danger" icon="pi pi-trash"
      (click)="excluir()" [disabled]="excluindo"></button>
  </ng-template>
</p-dialog>
